module.exports = __webpack_public_path__ + "static/Magazine-Ad-6a1cfbe2a67eab6ec7fe84670b2c718f.jpg";